// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"17ebd240","391":"90d80fd5"}[chunkId] + ".chunk.css";
};